import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteReisekostenabrechnungStatusCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteReisekostenabrechnungStatusCommandService],
  exports: []
})
export class DeleteReisekostenabrechnungStatusCommandServiceModule { }
